import { createFileRoute } from '@tanstack/react-router';

import { REQUEST_AGENT_VIEWS } from '@apps/web/routes/_app/admin/agent-traces/request_agent_views';

export const Route = createFileRoute('/_app/admin/agent-traces/client')({
    head: () => ({ meta: [{ title: REQUEST_AGENT_VIEWS.client.title }] }),
});
